// //Article page print Recipe
// if (document.querySelector("#btn-print")) {
//   document.querySelector("#btn-print").onclick = () => printDiv();
//   function printDiv() {
//     console.log("click");
//     let divContent = document.getElementById("recipe-content").innerHTML;
//     let printFrame = document.createElement("iframe");

//     printFrame.style.position = "absolute";
//     printFrame.style.width = "0px";
//     printFrame.style.height = "0px";
//     printFrame.style.border = "none";

//     document.body.appendChild(printFrame);

//     let doc = printFrame.contentWindow.document;
//     doc.open();
//     doc.write(`${divContent}`);
//     doc.close();

//     printFrame.contentWindow.focus();
//     printFrame.contentWindow.print();

//     document.body.removeChild(printFrame);
//   }
// }

// //Article Share function
// if (document.querySelector("#shareBtn")) {
//   document.querySelector("#shareBtn").addEventListener("click", function () {
//     if (navigator.share) {
//       navigator
//         .share({
//           title: document.title,
//           url: window.location.href,
//         })
//         .then(() => console.log("Shared successfully"))
//         .catch((error) => console.log("Error sharing:", error));
//     } else {
//       copyToClipboard();
//     }
//   });
// }

// // -------- Blog listing filter -------
// const buttons = document.querySelectorAll(".filter-button");
// buttons.forEach((button) => {
//   button.addEventListener("click", (e) => {
//     e.stopPropagation();
//     const targetId = button.getAttribute("data-target");
//     const dropdown = document.getElementById(targetId);
//     document.querySelectorAll(".filter-dropdown").forEach((d) => {
//       if (d.id !== targetId) {
//         d.classList.remove("open");
//       }
//     });
//     document
//       .querySelectorAll(".filter-button")
//       .forEach((b) => b.classList.remove("active"));
//     const isOpen = dropdown.classList.toggle("open");
//     if (isOpen) {
//       button.classList.add("active");
//     } else {
//       button.classList.remove("active");
//     }
//   });
// });

// document.addEventListener("click", () => {
//   document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
//     dropdown.classList.remove("open");
//   });
//   document.querySelectorAll(".filter-button").forEach((button) => {
//     button.classList.remove("active");
//   });
// });

// document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
//   dropdown.addEventListener("click", (e) => {
//     e.stopPropagation();
//   });
// });

// const articles = document.querySelectorAll(".blog-article-box-main");
// const filters = document.querySelector(".filters");
// const prepTimeRadios = document.querySelectorAll('input[name="prep-time"]');
// const foodTypeRadios = document.querySelectorAll('input[name="product-type"]');
// const applyButtons = document.querySelectorAll(".apply-btn");

// function filterArticles() {
//   const selectedPrepTime = document.querySelector(
//     'input[name="prep-time"]:checked'
//   )?.value;
//   const selectedFoodType = document.querySelector(
//     'input[name="product-type"]:checked'
//   )?.value;

//   // Check if any filter is active
//   const hasActiveFilters = selectedPrepTime || selectedFoodType;

//   const paginationWrapper = document.querySelector(
//     ".custom-pagination-wrapper"
//   );

//   articles.forEach(function (article) {
//     const articlePrepTime = article.getAttribute("data-prep-time");
//     const articleFoodType = article.getAttribute("data_food_type");
//     let shouldShow = true;

//     // Only apply prep time filter if it's selected
//     if (selectedPrepTime && selectedPrepTime !== "") {
//       shouldShow = shouldShow && articlePrepTime === selectedPrepTime;
//     }

//     // Only apply food type filter if it's selected
//     if (selectedFoodType && selectedFoodType !== "") {
//       shouldShow = shouldShow && articleFoodType === selectedFoodType;
//     }

//     if (shouldShow) {
//       article.classList.remove("hide");
//     } else {
//       article.classList.add("hide");
//     }
//   });

//   // Handle display states based on active filters
//   const displayFilt = document.querySelector(".display-filt");
//   const displayFiltPg = document.querySelector(".display-filt-pg");
//   const displayFiltPgg = document.querySelector(".display-filt-pg-");

//   if (hasActiveFilters) {
//     // Show filtered results, hide pagination
//     if (displayFilt) displayFilt.style.display = "grid";
//     if (displayFiltPg) displayFiltPg.style.display = "none";
//     if (displayFiltPgg) displayFiltPgg.style.display = "none";
//   } else {
//     // Show pagination, hide filtered results
//     if (displayFilt) displayFilt.style.display = "none";
//     if (displayFiltPg) displayFiltPg.style.display = "grid";
//     if (displayFiltPgg) displayFiltPgg.style.display = "grid";
//   }

//   // Handle pagination visibility
//   const visibleArticles = Array.from(articles).filter(
//     (article) => !article.classList.contains("hide")
//   );

//   if (paginationWrapper) {
//     paginationWrapper.style.display = hasActiveFilters ? "none" : "";
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   // Remove default checked state from all checkboxes
//   document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
//     checkbox.checked = false;
//   });

//   // Add event listeners for checkbox groups
//   const checkboxGroups = ["prep-time", "product-type"];
//   checkboxGroups.forEach((groupName) => {
//     document
//       .querySelectorAll(`input[name="${groupName}"]`)
//       .forEach((checkbox) => {
//         checkbox.addEventListener("change", function () {
//           // When a checkbox is checked, uncheck all others in the same group
//           if (this.checked) {
//             document
//               .querySelectorAll(`input[name="${groupName}"]`)
//               .forEach((otherCheckbox) => {
//                 if (otherCheckbox !== this) {
//                   otherCheckbox.checked = false;
//                 }
//               });
//           }
//         });
//       });
//   });
// });

// applyButtons.forEach((button) => {
//   button.addEventListener("click", function (e) {
//     e.preventDefault();
//     document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
//       dropdown.classList.remove("active");
//       dropdown.classList.remove("open");
//     });
//     document.querySelectorAll(".filter-button").forEach((filterBtn) => {
//       filterBtn.classList.remove("active");
//     });

//     // Re-run filter logic after applying
//     filterArticles();
//   });
// });

// document.querySelectorAll(".filter-button").forEach((button) => {
//   button.addEventListener("click", function (e) {
//     e.preventDefault();
//     document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
//       dropdown.classList.remove("active");
//     });
//     document.querySelectorAll(".filter-button").forEach((filterBtn) => {
//       if (filterBtn !== this) {
//         filterBtn.classList.remove("active");
//       }
//     });
//     const targetId = this.getAttribute("data-target");
//     const dropdown = document.getElementById(targetId);
//     dropdown.classList.toggle("active");
//   });
// });

// document.addEventListener("click", function (event) {
//   if (!event.target.closest(".filter-group")) {
//     document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
//       dropdown.classList.remove("active");
//       dropdown.removeAttribute("open");
//     });
//     document.querySelectorAll(".filter-button").forEach((button) => {
//       button.classList.remove("active");
//     });
//   }
// });

// let all = document.querySelectorAll(".filter-dropdown");

// document.querySelectorAll(".clear-btn").forEach((button) => {
//   button.addEventListener("click", function (e) {
//     e.preventDefault();
//     const dropdown = this.closest(".filter-dropdown");
//     dropdown.querySelectorAll("input").forEach((radio) => {
//       radio.checked = false;
//     });
//     const filterButton = document.querySelector(
//       `[data-target="${dropdown.id}"]`
//     );
//     filterButton.classList.remove("active");
//     dropdown.classList.remove("active");
//     dropdown.classList.remove("open");

//     // Re-run filter logic after clearing
//     filterArticles();
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const mobileArticles = document.querySelectorAll(
//     ".mobile-articles-container .blog-article-box-main"
//   );
//   const readMoreBtn = document.querySelector(".read-more-btn");
//   const articlesPerPage = 3;
//   let currentPage = 1;
//   const totalPages = Math.ceil(mobileArticles.length / articlesPerPage);
//   mobileArticles.forEach((article, index) => {
//     if (index >= articlesPerPage) {
//       article.style.display = "none";
//     } else {
//       article.style.display = "block";
//     }
//   });
//   if (readMoreBtn) {
//     readMoreBtn.addEventListener("click", function () {
//       currentPage++;
//       const startIndex = (currentPage - 1) * articlesPerPage;
//       const endIndex = startIndex + articlesPerPage;
//       for (
//         let i = startIndex;
//         i < Math.min(endIndex, mobileArticles.length);
//         i++
//       ) {
//         mobileArticles[i].style.display = "block";
//       }
//       if (currentPage >= totalPages) {
//         readMoreBtn.style.display = "none";
//       }
//     });
//     if (mobileArticles.length <= articlesPerPage) {
//       readMoreBtn.style.display = "none";
//     }
//   }
// });

let currentPage = 1; // Global

function initMobilePagination() {
  const mobileArticles = document.querySelectorAll(
    ".mobile-articles-container .blog-article-box-main"
  );
  const readMoreBtn = document.querySelector(".read-more-btn");
  const articlesPerPage = 3;
  const totalPages = Math.ceil(mobileArticles.length / articlesPerPage);

  // Reset currentPage
  currentPage = 1;

  // Hide all, show first page
  mobileArticles.forEach((article, index) => {
    if (index >= articlesPerPage) {
      article.style.display = "none";
    } else {
      article.style.display = "block";
    }
  });

  if (readMoreBtn) {
    // Remove previous event listeners by cloning
    const newBtn = readMoreBtn.cloneNode(true);
    readMoreBtn.parentNode.replaceChild(newBtn, readMoreBtn);

    newBtn.style.display =
      mobileArticles.length > articlesPerPage ? "block" : "none";

    newBtn.addEventListener("click", function () {
      currentPage++;
      const startIndex = (currentPage - 1) * articlesPerPage;
      const endIndex = startIndex + articlesPerPage;
      for (
        let i = startIndex;
        i < Math.min(endIndex, mobileArticles.length);
        i++
      ) {
        mobileArticles[i].style.display = "block";
      }
      if (currentPage >= totalPages) {
        newBtn.style.display = "none";
      }
    });
  }
}

// On page load
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    initMobilePagination();
  }
});

// After clearing filters
document.querySelectorAll(".clear-btn").forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    const dropdown = this.closest(".filter-dropdown");
    dropdown.querySelectorAll("input").forEach((radio) => {
      radio.checked = false;
    });
    const filterButton = document.querySelector(
      `[data-target="${dropdown.id}"]`
    );
    filterButton.classList.remove("active");
    dropdown.classList.remove("active");
    dropdown.classList.remove("open");

    // Re-run filter logic after clearing
    filterArticles();

    // Remove .hide from all mobile articles
    document
      .querySelectorAll(".mobile-articles-container .blog-article-box-main")
      .forEach((article) => {
        article.classList.remove("hide");
      });
    // Re-initialize pagination
    if (window.innerWidth <= 768) {
      initMobilePagination();
    }
  });
});

//Article page print Recipe
if (document.querySelector("#btn-print")) {
  document.querySelector("#btn-print").onclick = () => printDiv();
  function printDiv() {
    console.log("click");
    let divContent = document.getElementById("recipe-content").innerHTML;
    let printFrame = document.createElement("iframe");

    printFrame.style.position = "absolute";
    printFrame.style.width = "0px";
    printFrame.style.height = "0px";
    printFrame.style.border = "none";

    document.body.appendChild(printFrame);

    let doc = printFrame.contentWindow.document;
    doc.open();
    doc.write(`${divContent}`);
    doc.close();

    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();

    document.body.removeChild(printFrame);
  }
}

//Article Share function
if (document.querySelector("#shareBtn")) {
  document.querySelector("#shareBtn").addEventListener("click", function () {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.log("Error sharing:", error));
    } else {
      copyToClipboard();
    }
  });
}

// -------- Blog listing filter -------
const buttons = document.querySelectorAll(".filter-button");
buttons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.stopPropagation();
    const targetId = button.getAttribute("data-target");
    const dropdown = document.getElementById(targetId);
    document.querySelectorAll(".filter-dropdown").forEach((d) => {
      if (d.id !== targetId) {
        d.classList.remove("open");
      }
    });
    document
      .querySelectorAll(".filter-button")
      .forEach((b) => b.classList.remove("active"));
    const isOpen = dropdown.classList.toggle("open");
    if (isOpen) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });
});

document.addEventListener("click", () => {
  document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
    dropdown.classList.remove("open");
  });
  document.querySelectorAll(".filter-button").forEach((button) => {
    button.classList.remove("active");
  });
});

document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
  dropdown.addEventListener("click", (e) => {
    e.stopPropagation();
  });
});

const articles = document.querySelectorAll(".blog-article-box-main");
const filters = document.querySelector(".filters");
const prepTimeRadios = document.querySelectorAll('input[name="prep-time"]');
const foodTypeRadios = document.querySelectorAll('input[name="product-type"]');
const applyButtons = document.querySelectorAll(".apply-btn");

function filterArticles() {
  const isMobile = window.innerWidth <= 768;
  const articlesPerPage = 3;
  const selectedPrepTime = document.querySelector(
    'input[name="prep-time"]:checked'
  )?.value;
  const selectedFoodType = document.querySelector(
    'input[name="product-type"]:checked'
  )?.value;

  // Check if any filter is active
  const hasActiveFilters = selectedPrepTime || selectedFoodType;

  const paginationWrapper = document.querySelector(
    ".custom-pagination-wrapper"
  );

  // Reset current page when filters are applied
  currentPage = 1;

  // Get correct article set for device
  let articleSelector = isMobile
    ? ".mobile-articles-container .blog-article-box-main"
    : ".blog-article-box-main";
  let articles = document.querySelectorAll(articleSelector);

  // Hide 'No Results' message if present
  let noResultsMsg = document.querySelector(".no-results-message");
  if (noResultsMsg) noResultsMsg.style.display = "none";

  // Filter logic with case handling
  let visibleCount = 0;
  articles.forEach(function (article) {
    let articlePrepTime = article.getAttribute("data-prep-time");
    let articleFoodType = article.getAttribute("data_food_type");
    let shouldShow = true;

    if (isMobile) {
      // Mobile: compare in uppercase
      if (selectedPrepTime && selectedPrepTime !== "") {
        shouldShow =
          shouldShow && articlePrepTime === selectedPrepTime.toUpperCase();
      }
      if (selectedFoodType && selectedFoodType !== "") {
        shouldShow =
          shouldShow && articleFoodType === selectedFoodType.toUpperCase();
      }
    } else {
      // Desktop: compare in lowercase
      if (selectedPrepTime && selectedPrepTime !== "") {
        shouldShow =
          shouldShow && articlePrepTime === selectedPrepTime.toLowerCase();
      }
      if (selectedFoodType && selectedFoodType !== "") {
        shouldShow =
          shouldShow && articleFoodType === selectedFoodType.toLowerCase();
      }
    }

    if (shouldShow) {
      article.classList.remove("hide");
      visibleCount++;
    } else {
      article.classList.add("hide");
    }
  });

  // Handle display states based on active filters (desktop only)
  if (!isMobile) {
    const displayFilt = document.querySelector(".display-filt");
    const displayFiltPg = document.querySelector(".display-filt-pg");
    const displayFiltPgg = document.querySelector(".display-filt-pg-");
    if (hasActiveFilters) {
      if (displayFilt) displayFilt.style.display = "grid";
      if (displayFiltPg) displayFiltPg.style.display = "none";
      if (displayFiltPgg) displayFiltPgg.style.display = "none";
    } else {
      if (displayFilt) displayFilt.style.display = "none";
      if (displayFiltPg) displayFiltPg.style.display = "grid";
      if (displayFiltPgg) displayFiltPgg.style.display = "grid";
    }
    if (paginationWrapper) {
      paginationWrapper.style.display = hasActiveFilters ? "none" : "";
    }
  }

  // Mobile pagination and Read More button
  if (isMobile) {
    const mobileArticles = document.querySelectorAll(
      ".mobile-articles-container .blog-article-box-main"
    );
    const readMoreBtn = document.querySelector(".read-more-btn");
    let shown = 0;
    // Show only first N visible articles, hide the rest
    mobileArticles.forEach((article) => {
      if (!article.classList.contains("hide")) {
        shown++;
        if (shown <= articlesPerPage) {
          article.style.display = "block";
        } else {
          article.style.display = "none";
        }
      } else {
        article.style.display = "none";
      }
    });
    // Show/hide Read More button
    if (readMoreBtn) {
      readMoreBtn.style.display =
        visibleCount > articlesPerPage ? "block" : "none";
    }
    // Show 'No Results' message if nothing matches
    if (visibleCount === 0) {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement("div");
        noResultsMsg.className = "no-results-message";
        noResultsMsg.textContent = "No articles found.";
        document
          .querySelector(".mobile-articles-container")
          .appendChild(noResultsMsg);
      }
      noResultsMsg.style.display = "block";
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialize display states
  const displayFilt = document.querySelector(".display-filt");
  const displayFiltPg = document.querySelector(".display-filt-pg");
  const displayFiltPgg = document.querySelector(".display-filt-pg-");

  // Set initial display states
  if (displayFilt) displayFilt.style.display = "none";
  if (displayFiltPg) displayFiltPg.style.display = "grid";
  if (displayFiltPgg) displayFiltPgg.style.display = "grid";

  // Remove default checked state from all checkboxes
  document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
    checkbox.checked = false;
  });

  // Add event listeners for checkbox groups
  const checkboxGroups = ["prep-time", "product-type"];
  checkboxGroups.forEach((groupName) => {
    document
      .querySelectorAll(`input[name="${groupName}"]`)
      .forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
          // When a checkbox is checked, uncheck all others in the same group
          if (this.checked) {
            document
              .querySelectorAll(`input[name="${groupName}"]`)
              .forEach((otherCheckbox) => {
                if (otherCheckbox !== this) {
                  otherCheckbox.checked = false;
                }
              });
          }
        });
      });
  });
});

applyButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
      dropdown.classList.remove("active");
      dropdown.classList.remove("open");
    });
    document.querySelectorAll(".filter-button").forEach((filterBtn) => {
      filterBtn.classList.remove("active");
    });

    // Re-run filter logic after applying
    filterArticles();
  });
});

document.querySelectorAll(".filter-button").forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
      dropdown.classList.remove("active");
    });
    document.querySelectorAll(".filter-button").forEach((filterBtn) => {
      if (filterBtn !== this) {
        filterBtn.classList.remove("active");
      }
    });
    const targetId = this.getAttribute("data-target");
    const dropdown = document.getElementById(targetId);
    dropdown.classList.toggle("active");
  });
});

document.addEventListener("click", function (event) {
  if (!event.target.closest(".filter-group")) {
    document.querySelectorAll(".filter-dropdown").forEach((dropdown) => {
      dropdown.classList.remove("active");
      dropdown.removeAttribute("open");
    });
    document.querySelectorAll(".filter-button").forEach((button) => {
      button.classList.remove("active");
    });
  }
});

let all = document.querySelectorAll(".filter-dropdown");

function updateCartSubtotal() {
  const subtotalExclDeliveryElement = document.querySelector('[data-subtotal-excl-delivery]');
  const deliveryCostElement = document.querySelector('[data-delivery-cost]');
  const freeShippingBar = document.querySelector('.free-shipping-bar');
  
  if (!freeShippingBar) {
    return;
  }
  
  const threshold = parseInt(freeShippingBar.getAttribute('data-threshold')) || 12000;
  const deliveryRate = parseInt(freeShippingBar.getAttribute('data-delivery-rate')) || 999;
  
  // Get original cart total (without delivery) from the data attribute
  const cartTotalAttr = freeShippingBar.getAttribute('data-cart-total');
  let originalCartTotal = 0;
  
  if (cartTotalAttr) {
    originalCartTotal = parseInt(cartTotalAttr);
  }
  
  if (subtotalExclDeliveryElement) {
    const exclDeliveryText = (originalCartTotal / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    subtotalExclDeliveryElement.textContent = exclDeliveryText;
  }
  
  if (deliveryCostElement) {
    if (originalCartTotal >= threshold) {
      deliveryCostElement.textContent = 'FREE';
    } else {
      const deliveryText = (deliveryRate / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      deliveryCostElement.textContent = deliveryText;
    }
  }
  
  let finalTotal = originalCartTotal;
  if (originalCartTotal < threshold) {
    finalTotal = originalCartTotal + deliveryRate;
  }
  
  const subtotalElements = document.querySelectorAll('[data-subtotal]');
  if (subtotalElements.length > 0) {
    const finalSubtotalText = (finalTotal / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    
    subtotalElements.forEach((element) => {
      element.textContent = finalSubtotalText;
    });
  }
}

function updateFreeShippingBar() {
  const freeShippingBar = document.querySelector('.free-shipping-bar');
  if (!freeShippingBar) return;

  const threshold = parseInt(freeShippingBar.getAttribute('data-threshold')) || 12000;
  const messageBelow = freeShippingBar.getAttribute('data-message-below') || 'You\'re just $AMOUNT away from FREE DELIVERY';
  const messageEligible = freeShippingBar.getAttribute('data-message-eligible') || '🎉 Congratulations! You\'re eligible for FREE DELIVERY';
  const shippingIcon = freeShippingBar.getAttribute('data-shipping-icon') || '';

  const cartTotalAttr = freeShippingBar.getAttribute('data-cart-total');
  let originalCartTotal = 0;
  
  if (cartTotalAttr) {
    originalCartTotal = parseInt(cartTotalAttr);
  }

  const progressBar = freeShippingBar.querySelector('.progress-bar');
  const messageText = freeShippingBar.querySelector('.shipping-message-text');
  const goalAmount = freeShippingBar.querySelector('.goal-amount');
  const iconElement = freeShippingBar.querySelector('.sleigh-icon');

  if (goalAmount) {
    goalAmount.textContent = '$' + (threshold / 100).toFixed(2);
  }

  if (iconElement && shippingIcon) {
    iconElement.src = shippingIcon;
  }

  if (originalCartTotal >= threshold) {
    freeShippingBar.classList.add('eligible');
    if (progressBar) {
      progressBar.style.width = '100%';
      progressBar.setAttribute('data-progress', '100');
    }
    if (messageText) {
      messageText.innerHTML = messageEligible;
    }
  } else {
    freeShippingBar.classList.remove('eligible');
    const remaining = threshold - originalCartTotal;
    const progress = (originalCartTotal / threshold) * 100;
    const remainingDollars = (remaining / 100).toFixed(2);

    if (progressBar) {
      progressBar.style.width = progress + '%';
      progressBar.setAttribute('data-progress', progress.toString());
    }
    if (messageText) {
      const message = messageBelow.replace('$AMOUNT', '$' + remainingDollars);
      messageText.innerHTML = message;
    }
  }
  
}

function fetchAndUpdateCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const freeShippingBar = document.querySelector('.free-shipping-bar');
      if (freeShippingBar) {
        freeShippingBar.setAttribute('data-cart-total', cart.total_price.toString());
      }
      updateFreeShippingBar();
      updateCartSubtotal();
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

document.addEventListener('DOMContentLoaded', function() {
  updateFreeShippingBar();
  updateCartSubtotal();
  const cartContainer = document.querySelector('[data-products]');
  if (cartContainer) {
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        setTimeout(fetchAndUpdateCart, 100);
      }
    });
    
    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-key', 'value']
    });
  }
});

document.addEventListener('cart:updated', function() {
  setTimeout(fetchAndUpdateCart, 100);
});

document.addEventListener('cart:drawer:updated', function() {
  setTimeout(fetchAndUpdateCart, 100);
});

document.addEventListener('cart:refresh', function() {
  setTimeout(fetchAndUpdateCart, 100);
});

document.addEventListener('cart:change', function() {
  setTimeout(fetchAndUpdateCart, 100);
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.cart__qty-input, .cart__remove, [data-cart-quantity], .js-qty__num')) {
    setTimeout(fetchAndUpdateCart, 150);
  }
});

document.addEventListener('submit', function(event) {
  if (event.target.matches('#CartPageForm, .cart-form')) {
    setTimeout(fetchAndUpdateCart, 200);
  }
});

document.addEventListener('click', function(event) {
  if (event.target.matches('.js-qty__adjust')) {
    setTimeout(fetchAndUpdateCart, 150);
  }
});

document.addEventListener('input', function(event) {
  if (event.target.matches('.js-qty__num')) {
    setTimeout(fetchAndUpdateCart, 300);
  }
});

document.addEventListener('click', function(event) {
  if (event.target.matches('.cart-drawer .js-qty__adjust, .cart-drawer .js-qty__num')) {
    setTimeout(fetchAndUpdateCart, 200);
  }
});

const originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = args[0];
  if (typeof url === 'string' && (url.includes('/cart/change.js') || url.includes('/cart/add.js') || url.includes('/cart/update.js'))) {
    return originalFetch.apply(this, args).then(response => {
      if (response.ok) {
        setTimeout(fetchAndUpdateCart, 100);
      }
      return response;
    });
  }
  return originalFetch.apply(this, args);
};

document.addEventListener('click', function(event) {
  const removeButton = event.target.closest('[data-cart-remove]');
  if (removeButton) {
    event.preventDefault();
    
    const itemKey = removeButton.getAttribute('data-id');
    if (!itemKey) return;

    removeButton.classList.add('loading');
    const originalText = removeButton.querySelector('span').textContent;
    removeButton.querySelector('span').textContent = 'Removing...';
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      const cartItem = document.querySelector(`[data-key="${itemKey}"]`);
      if (cartItem) {
        cartItem.classList.add('removing');
        setTimeout(() => {
          cartItem.remove();
          
          const remainingItems = document.querySelectorAll('[data-products] .cart__item');
          if (remainingItems.length === 0) {
            handleEmptyCart();
          } else {
            updateCartTotalsAfterRemoval(cart);
            setTimeout(() => {
              updateFreeShippingBar();
            }, 100);
          }
        }, 300);
      }
    })
    .catch(error => {
      console.error('Error removing item from cart:', error);
      removeButton.classList.remove('loading');
      removeButton.querySelector('span').textContent = originalText;
    });
  }
});

function handleEmptyCart() {
  const cartItemsSection = document.querySelector('[data-products]');
  if (cartItemsSection) {
    cartItemsSection.style.display = 'none';
  }
  
  const cartFooter = document.querySelector('.cart__footer');
  if (cartFooter) {
    cartFooter.style.display = 'none';
  }
  
  const freeShippingBar = document.querySelector('.free-shipping-bar');
  if (freeShippingBar) {
    freeShippingBar.style.display = 'none';
  }

  const cartItemsEl = document.querySelector('.cart_form_left');
  if (cartItemsEl) {
    cartItemsEl.style.display = 'none';
  }
  
  const emptyCartText = document.querySelector('.cart__empty-text');
  if (emptyCartText) {
    emptyCartText.style.display = 'block';
  }

  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    sectionHeader.classList.add('section-header--404');
  } 
}


function updateCartTotalsAfterRemoval(cart) {
  const originalCartTotal = cart.total_price;
  const threshold = 12000;
  const deliveryRate = 999;
  
  const subtotalExclDeliveryElement = document.querySelector('[data-subtotal-excl-delivery]');
  if (subtotalExclDeliveryElement) {
    const newValue = (originalCartTotal / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    subtotalExclDeliveryElement.textContent = newValue;
  }
  
  const deliveryCostElement = document.querySelector('[data-delivery-cost]');
  if (deliveryCostElement) {
    if (originalCartTotal >= threshold) {
      deliveryCostElement.textContent = 'FREE';
    } else {
      const deliveryValue = (deliveryRate / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      deliveryCostElement.textContent = deliveryValue;
    }
  }

  const subtotalElements = document.querySelectorAll('[data-subtotal]');
  if (subtotalElements.length > 0) {
    let finalTotal = originalCartTotal;
    if (originalCartTotal < threshold) {
      finalTotal = originalCartTotal + deliveryRate;
    }
    
    const finalValue = (finalTotal / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    subtotalElements.forEach((element) => {
      element.textContent = finalValue;
    });
  }
  
  const freeShippingBar = document.querySelector('.free-shipping-bar');
  if (freeShippingBar) {
    freeShippingBar.setAttribute('data-cart-total', originalCartTotal.toString());
  }
  
  const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
  cartCountElements.forEach(element => {
    element.textContent = cart.item_count;
  });
}
